import $ from 'jquery';
import { $window } from '../variables/variables.js';
import { debounce } from '../functions/functions.js';



$( () => {
	const $units = $( '.conditions__questions-unit' );

	if ( ! $units.length ) {
		return;
	}

	$units.on( 'click', function() {
		$( this ).toggleClass( 'conditions__questions-unit_active' );
	} );

	function setTextHeight() {
		$units.each( function() {
			const $unit     = $( this );
			const $text     = $unit.find( '.conditions__questions-text' );
			const IS_ACTIVE = $unit.hasClass( 'conditions__questions-unit_active' );

			$unit.addClass( 'trans-off' );

			if ( ! IS_ACTIVE ) {
				$unit.addClass( 'conditions__questions-unit_active' );
			}

			$text.removeAttr( 'style' );
			$text.css( 'max-height', $text.height() );

			if ( ! IS_ACTIVE ) {
				$unit.removeClass( 'conditions__questions-unit_active' );
			}
			$unit.removeClass( 'trans-off' );
		} );
	}
	setTextHeight();
	$window.on( 'resizeWidth', debounce( setTextHeight ) );
} );
